import React from 'react';
import HeaderTwo from './header/HeaderTwo';
import FooterTwo from './footer/FooterTwo';

const Layout = ( { children } ) => {
    return (
        <>
            <main className="main-wrapper">
                <HeaderTwo styles="header-style-2" searchDisable buttonStyle="bg-color-white" />
                { children }
                <FooterTwo />
            </main>
        </>
    )
}
export default Layout;